import script from "./Sectors.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sectors.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__